import { FC } from 'react';
import {
  HeaderMenuContainer,
  Left,
  Right,
  Center,
  Chapters,
  Chapter,
  ChapterWrapper,
} from './styled';
import { texts } from '../locale';

type Props = {
  isOpen: boolean;
  timelineAnchor: number;
  handleLeft: () => void;
  handleRight: () => void;
};

const menuItems = [
  texts.menu_1,
  texts.menu_3,
  texts.menu_5,
  texts.menu_7,
  texts.menu_9,
  texts.menu_11,
  texts.menu_13,
  texts.menu_15,
  texts.menu_17,
];

export const HeaderMenu: FC<Props> = ({
  isOpen,
  timelineAnchor,
  handleLeft,
  handleRight,
}) => {
  return (
    <HeaderMenuContainer $isOpen={isOpen}>
      <Left onClick={() => handleLeft()}>
        {timelineAnchor === 1 ? '' : <div>{timelineAnchor - 1}</div>}
      </Left>
      <Center>
        <Chapters $position={timelineAnchor}>
          {menuItems.map((item) => (
            <Chapter key={item}>
              <ChapterWrapper>{item}</ChapterWrapper>
            </Chapter>
          ))}
        </Chapters>
      </Center>
      <Right onClick={() => handleRight()}>
        {timelineAnchor === 9 ? '' : <div>{timelineAnchor + 1}</div>}
      </Right>
    </HeaderMenuContainer>
  );
};
